import logo from "../assets/img/logo.png";
import ourMission from "../assets/img/ourMission.png";
import ourStory from "../assets/img/ourStory.png";
import ourStory2 from "../assets/img/ourStory2.png";
import ourStory3 from "../assets/img/ourStory3.png";
import nftSupply1 from "../assets/img/nftSupply1.png";
import nftSupply2 from "../assets/img/nftSupply2.png";
import nftSupply3 from "../assets/img/nftSupply3.png";
import rewards from "../assets/img/rewards.png";
import roadmap from "../assets/img/roadmap.png";
import facebook from "../assets/img/icons/facebook.png";
import discord from "../assets/img/icons/discord.png";
import twitter from "../assets/img/icons/twitter.png";
import linkedin from "../assets/img/icons/linkedin.png";
import medium from "../assets/img/icons/medium.png";
import circle from "../assets/img/icons/circle.svg";
import circleOpen from "../assets/img/icons/circle-open.svg";
import blog1 from "../assets/img/blog1.png";
import blog2 from "../assets/img/blog2.png";
import opensea from "../assets/img/Opensea.png";
import video from "../assets/Elements/Video.mp4";
import nftBotUtility from "../assets/img/nftUtility.gif";
import nftBotUtilityMobile from "../assets/img/nftUtilityMobile.gif";
import whitelist from "../assets/img/Whitelist.png";
import whitelistNFT from "../assets/img/whitelist-img.png";
import whitelistBanner from "../assets/img/whitelistBanner.png";
import whitelistBannerMobile from "../assets/img/whitelist-mobile.jpg";
import whitelistMarquee from "../assets/img/whitelist-marquee.gif";
import faqHeading from "../assets/img/faqHeading.png";
import walletAddress from "../assets/img/wallet_address.png";
import mintBanner from "../assets/img/mint-banner.png";
import rewardBanner from "../assets/img/rewardBanner.png";
import stakingBanner from "../assets/img/stakingBanner.png";
// Assets
import asset1 from "../assets/Elements/assets/1.png";
import asset2 from "../assets/Elements/assets/2.png";
import asset3 from "../assets/Elements/assets/3.png";
import asset4 from "../assets/Elements/assets/4.png";
import asset5 from "../assets/Elements/assets/5.png";
import asset6 from "../assets/Elements/assets/6.png";
import asset7 from "../assets/Elements/assets/7.png";
import asset8 from "../assets/Elements/assets/8.png";
import asset9 from "../assets/Elements/assets/9.png";
import asset10 from "../assets/Elements/assets/10.png";
import asset11 from "../assets/Elements/assets/11.png";
import asset12 from "../assets/Elements/assets/12.png";
import asset13 from "../assets/Elements/assets/13.png";
import asset14 from "../assets/Elements/assets/14.png";
import asset15 from "../assets/Elements/assets/15.png";
import asset16 from "../assets/Elements/assets/16.png";
import asset17 from "../assets/Elements/assets/17.png";
import asset18 from "../assets/Elements/assets/18.png";
import asset19 from "../assets/Elements/assets/19.png";
import asset20 from "../assets/Elements/assets/20.png";
import asset21 from "../assets/Elements/assets/21.png";
// Nft's
import nft1 from "../assets/img/nft/1.png";
import nft2 from "../assets/img/nft/2.png";
import nft3 from "../assets/img/nft/3.png";
import nft4 from "../assets/img/nft/4.png";
import nft5 from "../assets/img/nft/5.png";
import nft6 from "../assets/img/nft/6.png";
import staked from "../assets/img/nft/staked.png";

export const images = {
	logo,
	ourMission,
	ourStory,
	ourStory2,
	ourStory3,
	nftSupply1,
	nftSupply2,
	nftSupply3,
	rewards,
	roadmap,
	facebook,
	discord,
	twitter,
	linkedin,
	medium,
	blog1,
	blog2,
	video,
	nftBotUtility,
	nftBotUtilityMobile,
	whitelist,
	asset1,
	asset2,
	asset3,
	asset4,
	asset5,
	asset6,
	asset7,
	asset8,
	asset9,
	asset10,
	asset11,
	asset12,
	asset13,
	asset14,
	asset15,
	asset16,
	asset17,
	asset18,
	asset19,
	asset20,
	asset21,

	circle,
	circleOpen,
	opensea,
	whitelistNFT,
	faqHeading,
	walletAddress,
	whitelistMarquee,
	whitelistBanner,
	whitelistBannerMobile,
	mintBanner,
	rewardBanner,
	stakingBanner,
	nft1,
	nft2,
	nft3,
	nft4,
	nft5,
	nft6,
	staked,
};
